import type { DesktopNavKey } from '@/components/ri/DesktopSidebar';
import { ADMIN_ROUTES } from '@/components/layout/nav/adminRoutes';

export const DESKTOP_NAV_HREF: Record<Exclude<DesktopNavKey, 'admin'>, string> = {
  home: '/',
  accounts: '/accounts',
  quotes: '/quotes',
  events: '/events',
  approvals: '/approvals',
  'how-to': '/how-to',
  'whats-new': '/whats-new',
};

export function desktopNavHref(key: DesktopNavKey): string {
  return key === 'admin' ? ADMIN_ROUTES[0].path : DESKTOP_NAV_HREF[key];
}

// Matches the `hiddenFrom="sm"` breakpoint the shell uses for its mobile navigation.
export const MOBILE_NAV_QUERY = '(max-width: 47.99em)';

// A signed-in event workspace owns its own mobile header and tab bar ("event mode").
export function isEventModePath(pathname: string): boolean {
  return /^\/events\/(?!offline(?:\/|$))[^/]+\/?$/.test(pathname);
}
